import { morph } from '@theme/morph';

const variantOf = (href) => new URL(href, location.href).searchParams.get('variant');

let current = variantOf(location.href);

async function swap(url) {
  document.documentElement.dataset.frjSwapping = '';

  try {
    const html = await fetch(url).then((response) => response.text());
    const next = new DOMParser().parseFromString(html, 'text/html');

    // морф тягне checked зі свіжого HTML, де завжди обрана підписка, —
    // вибір «разова покупка» має пережити свіч смаку
    const plan = document.querySelector('input[name="selling_plan"]:checked')?.value;

    for (const section of document.querySelectorAll('[data-frj-variant-section]')) {
      const wrapper = section.closest('[id^="shopify-section-"]') ?? section;
      const fresh = next.getElementById(wrapper.id);
      if (!fresh) continue;

      morph(wrapper, fresh);
      for (const carousel of wrapper.querySelectorAll('swiper-container')) carousel.swiper?.update();
    }

    if (plan != null) {
      const input = document.querySelector(`input[name="selling_plan"][value="${CSS.escape(plan)}"]`);
      if (input) input.checked = true;
    }

    // морф може замінити вузли всередині секцій (форма buybox не переживає
    // свіч) — слухачі, що тримають посилання на DOM, мають перепідписатись;
    // подія тільки після успішного морфу: на фейлі йде повна навігація
    document.dispatchEvent(new CustomEvent('frj:variant-swap'));
  } catch {
    location.assign(url);
  } finally {
    delete document.documentElement.dataset.frjSwapping;
  }
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-variant]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

  event.preventDefault();
  if (link.dataset.variant === current) return;

  const url = new URL(location.href);
  url.searchParams.set('variant', link.dataset.variant);
  current = link.dataset.variant;
  history.pushState({}, '', url);
  swap(url);
});

addEventListener('popstate', () => {
  const next = variantOf(location.href);
  if (next === current) return;
  current = next;
  swap(location.href);
});
